import React from "react";
import "./settingsNew.css";

const SettingsIcon = () => {
  return <span className="prof-icon icon-profile_settings" />;
};

export default SettingsIcon;
